import { render } from "./Sizes.vue?vue&type=template&id=183300f5"
import script from "./Sizes.vue?vue&type=script&lang=js"
export * from "./Sizes.vue?vue&type=script&lang=js"
script.render = render

export default script